import { render, staticRenderFns } from "./Treaty.vue?vue&type=template&id=2c3eeada&scoped=true"
import script from "./Treaty.vue?vue&type=script&lang=js"
export * from "./Treaty.vue?vue&type=script&lang=js"
import style0 from "./Treaty.vue?vue&type=style&index=0&id=2c3eeada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3eeada",
  null
  
)

export default component.exports